export const APP_NAMES = {
  BEAVER: "beaver",
  BEAVER_BACKOFFICE: "beaver-endpoints",
  CLARITY: "clarity",
  COMMERCIAL_WEBSITE: "commercial-website",
  PHOTO_ALBUM: "photo-album",
  PHOTO_ALBUM2: "photo-album2",
  TENANT_FORM: "tenant-form",
  TOY_RECOMMENDATIONS: "toy-recommendation",
  FINANCIAL_DASHBOARD: "financial-dashboard",
  TIME_OWNER: "time-owner",
  MASHMAUTI: "mashmauti",
  MASHMAUTI_COMMERCIAL: "mashmauti-commercial",
  PAYLESS: "payless",
};
